import ItemBreakpoint from 'Custom/ItemBreakpoint';
import Link from 'node_modules/next/link';
import styles from 'styles/pages/sideEffects.module.scss';

const OTHER_PROBLEMS_LIST = [
  'Reacciones vasovagales (como disminución de la presión arterial, mareos o desmayos)',
  'Dolor, irritación, hinchazón o formación de moretones en el lugar de la inserción',
  'Entumecimiento y hormigueo en el lugar de inserción',
  'Formación de cicatrices, incluida una cicatriz gruesa llamada queloide alrededor del lugar de inserción',
  'Infección',
  'Puede formarse tejido cicatricial alrededor del implante, lo que podría dificultar la extracción',
  'El implante podría salirse solo. Si el implante se sale solo, usted podría quedar embarazada. Si el implante se sale, utilice un método anticonceptivo de respaldo y llame de inmediato a su profesional de la salud',
  'La necesidad de realizar una cirugía en el hospital para extraer el implante',
  'Daño en los nervios o vasos sanguíneos de su brazo',
  'El implante se rompe, lo que dificulta su extracción',
];

const BLOOD_CONDITIONS_LIST = [
  'Las piernas (trombosis venosa profunda)',
  'Los pulmones (embolia pulmonar)',
  'El cerebro (accidente cerebrovascular)',
  'El corazón (ataque cardíaco)',
  'Los ojos (ceguera total o parcial)',
];

const OTHER_RISKS_LIST = [
  'Presión arterial alta',
  'Problemas de la vesícula biliar',
  'Tumores de hígado cancerosos o no cancerosos raros',
];

const MENSTRUL_PERIODS_LIST = [
  'Un sangrado más prolongado o más breve durante sus períodos',
  'Ausencia de sangrado durante el momento en el que debería tener su período',
  'Manchado entre los períodos',
  'Variación en el tiempo entre sus períodos',
];

export const SE_LIST_1 = [
  'Cambios del estado de ánimo',
  'Estado de ánimo depresivo',
  'Aumento de peso',
  'Dolor de cabeza',
  'Acné',
];

export const SE_LIST_2 = [
  'Dolor de cabeza',
  'Vaginitis (inflamación de la vagina)',
  'Aumento de peso',
  'Acné',
  'Dolor en los senos',
  'Infecciones virales, como dolor de garganta o síntomas semejantes a la gripe',
  'Dolor de estómago',
  'Períodos menstruales dolorosos',
  'Cambios del estado de ánimo, nerviosismo o estado de ánimo depresivo',
  'Dolor de espalda',
  'Náuseas',
  'Mareos',
  'Dolor',
  'Dolor en el lugar de la inserción',
];

export const SE_TABLE_1 = [
  {
    title:
      'Cambio en los patrones de sangrado menstrual (períodos menstruales)',
    body: (
      <>
        <p>
          En estudios realizados, 1 de cada 10 mujeres dejó de usar NEXPLANON
          por un cambio desfavorable en su patrón de sangrado. Usted podría
          tener:
        </p>
        {MENSTRUL_PERIODS_LIST && (
          <ul>
            {MENSTRUL_PERIODS_LIST.map((item, i) => (
              <li key={`faq-se-mp-single${i}`}>{item}</li>
            ))}
          </ul>
        )}
        <p>
          Hable con su médico de inmediato si cree que podría estar embarazada o
          su sangrado menstrual es abundante y prolongado.
        </p>
      </>
    ),
  },
  {
    title:
      'Otros efectos secundarios frecuentes que causaron que las mujeres dejaran de usar NEXPLANON incluyen:',
    body: (
      <ItemBreakpoint>
        <>
          {SE_LIST_1 && (
            <div className={`${styles.splittedList} ${styles.noMargin}`}>
              <ul>
                {SE_LIST_1.slice(0, 3).map((item, i) => (
                  <li key={`faq-wte-se1-1${i}`}>{item}</li>
                ))}
              </ul>
              <ul>
                {SE_LIST_1.slice(3, 5).map((item, i) => (
                  <li key={`faq-wte-se1-2-${i}`}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </>
        <div className={styles.mobileList}>
          {SE_LIST_1 && (
            <ul>
              {SE_LIST_1.map((item, i) => (
                <li key={`faq-wte-se1-single${i}`}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      </ItemBreakpoint>
    ),
  },
  {
    title: 'Otros efectos secundarios frecuentes de NEXPLANON:',
    body: (
      <>
        <ItemBreakpoint>
          <>
            {SE_LIST_2 && (
              <div className={`${styles.splittedList} ${styles.noMargin}`}>
                <ul>
                  {SE_LIST_2.slice(0, 7).map((item, i) => (
                    <li key={`faq-wte-se-1-${i}`}>{item}</li>
                  ))}
                </ul>
                <ul>
                  {SE_LIST_2.slice(7, 15).map((item, i) => (
                    <li key={`faq-wte-se-2-${i}`}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </>
          <div className={styles.mobileList}>
            {SE_LIST_2 && (
              <ul>
                {SE_LIST_2.map((item, i) => (
                  <li key={`faq-wte-se-single-${i}`}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        </ItemBreakpoint>
        <p className={styles.mt}>
          Se han informado casos de implantes que se encontraron en un vaso
          sanguíneo, incluido un vaso sanguíneo del pulmón, lo que puede estar
          asociado con dificultad para respirar, tos y/o toser sangre o
          mucosidad con sangre.
        </p>
        <p>
          Esta no es una lista completa de los posibles efectos secundarios.
          Para obtener más información, pídale a su profesional de la salud que
          la asesore sobre los efectos secundarios que le preocupan. Puede
          informar a la FDA (Administración de Alimentos y Medicamentos) acerca
          de los efectos secundarios llamando al{' '}
          <Link
            data-design-category="content_link_vd"
            className={styles.phoneLink}
            href="tel:18003321088"
          >
            1-800-FDA-1088
          </Link>
          .
        </p>
      </>
    ),
  },
];

export const CONDITIONS_TABLE = {
  content: [
    'DIABETES',
    'COLESTEROL ELEVADO',
    'TRIGLICÉRIDOS ELEVADOS',
    'DOLORES DE CABEZA',
    'PROBLEMAS DE LA VESÍCULA BILIAR',
    'PROBLEMAS DE LOS RIÑONES',
    'ANTECEDENTES DE DEPRESIÓN',
    'PRESIÓN ARTERIAL ALTA',
  ],
  footnote: (
    <p>
      Antes de recibir NEXPLANON, informe al profesional de la salud capacitado
      si es alérgica a los medicamentos que se utilizan para anestesiar o a los
      antisépticos que se utilizan para limpiar la piel. Estos medicamentos se
      utilizarán al colocar o extraer el implante de su brazo.
    </p>
  ),
};

export const SE_TABLE_2 = [
  {
    title: 'Inserción incorrecta',
    body: (
      <>
        <p>
          Es posible que el implante no esté colocado en su brazo debido a una
          inserción fallida. Si esto sucede, usted podría quedar embarazada.
        </p>
        <p>
          Para asegurarse de que NEXPLANON está insertado correctamente, de
          inmediato después de la inserción usted y su profesional de la salud
          palparán el implante debajo de su piel. Si no puede sentir el
          implante, asegúrese de comunicárselo a su profesional de la salud.
        </p>
      </>
    ),
  },
  {
    title: 'La localización y la extracción podrían resultar difíciles',
    body: (
      <>
        <p>
          La localización y la extracción del implante podrían resultar
          difíciles o imposibles si el implante no está donde debería estar. Es
          posible que para extraer el implante se necesiten procedimientos
          especiales, incluida una cirugía en el hospital. Si el implante no se
          extrae, los efectos de NEXPLANON continuarán durante un tiempo más
          largo.
        </p>
        <p>
          Se han encontrado implantes en la arteria pulmonar (un vaso sanguíneo
          del pulmón). Si el implante no puede encontrarse en el brazo, es
          posible que su profesional de la salud le haga una radiografía del
          tórax o utilice otro método de diagnóstico por imágenes. Si el
          implante se encuentra en el pecho, es posible que se requiera una
          cirugía.
        </p>
      </>
    ),
  },
  {
    title: 'Otros problemas relacionados con la inserción y la extracción',
    body: (
      <ItemBreakpoint>
        <>
          {OTHER_PROBLEMS_LIST && (
            <div className={`${styles.splittedList} ${styles.noMargin}`}>
              <ul>
                {OTHER_PROBLEMS_LIST.slice(0, 5).map((item, i) => (
                  <li key={`faq-se-op-1${i}`}>{item}</li>
                ))}
              </ul>
              <ul>
                {OTHER_PROBLEMS_LIST.slice(5, 10).map((item, i) => (
                  <li key={`faq-se-op-2-${i}`}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </>
        <div className={styles.mobileList}>
          {OTHER_PROBLEMS_LIST && (
            <ul>
              {OTHER_PROBLEMS_LIST.map((item, i) => (
                <li key={`faq-se-op-single${i}`}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      </ItemBreakpoint>
    ),
  },
  {
    title: 'Embarazo ectópico',
    body: (
      <>
        <p>
          Si queda embarazada mientras utiliza NEXPLANON, usted tiene una
          probabilidad ligeramente más alta de que el embarazo sea ectópico
          (fuera del útero) que las mujeres que no utilizan métodos
          anticonceptivos.
        </p>
        <p>
          El sangrado vaginal fuera de lo común o el dolor en la parte inferior
          del abdomen pueden ser signos de un embarazo ectópico.
        </p>
        <p>
          El embarazo ectópico es una emergencia médica que a menudo requiere
          cirugía.
        </p>
        <p>
          Los embarazos ectópicos pueden provocar un sangrado interno grave,
          infertilidad e incluso la muerte. Si cree que está embarazada o tiene
          un dolor en la parte inferior del abdomen sin motivo aparente, llame
          de inmediato a su profesional de la salud.
        </p>
      </>
    ),
  },
  {
    title: 'Quistes ováricos y cáncer de mama',
    body: (
      <>
        <p>
          Es posible que se desarrollen quistes en los ovarios y, por lo
          general, desaparecen sin tratamiento, pero a veces es necesario
          recurrir a la cirugía para extirparlos.
        </p>
        <p>
          Se desconoce si el uso de NEXPLANON cambia el riesgo de que una mujer
          padezca cáncer de mama. Si usted tiene cáncer de mama actualmente, o
          tuvo en el pasado, no use NEXPLANON, ya que algunos tipos de cáncer de
          mama son sensibles a las hormonas.
        </p>
      </>
    ),
  },
  {
    title: 'Coágulos de sangre graves',
    body: (
      <>
        <p>
          NEXPLANON puede aumentar la probabilidad de que aparezcan coágulos de
          sangre graves, en especial si usted tiene otros factores de riesgo,
          como fumar. Es posible morir debido a un problema causado por un
          coágulo de sangre, como un ataque cardíaco o un accidente
          cerebrovascular.
        </p>
        <p>
          Algunos ejemplos de coágulos de sangre graves son coágulos de sangre
          en:
        </p>
        <ItemBreakpoint>
          <>
            {BLOOD_CONDITIONS_LIST && (
              <div className={styles.splittedList}>
                <ul>
                  {BLOOD_CONDITIONS_LIST.slice(0, 3).map((item, i) => (
                    <li key={`faq-bc-op-1${i}`}>{item}</li>
                  ))}
                </ul>
                <ul>
                  {BLOOD_CONDITIONS_LIST.slice(3, 5).map((item, i) => (
                    <li key={`faq-bc-op-2-${i}`}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </>
          {BLOOD_CONDITIONS_LIST && (
            <div className={styles.mobileList}>
              <ul>
                {BLOOD_CONDITIONS_LIST.map((item, i) => (
                  <li key={`faq-bc-op-21${i}`}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </ItemBreakpoint>
        <p>
          Las mujeres que fuman tienen mayor riesgo de tener coágulos de sangre
          graves. Si usted fuma y desea utilizar NEXPLANON, debe dejar de fumar.
          Su profesional de la salud puede ayudarla.
        </p>
        <p>
          Infórmele a su profesional de la salud al menos 4 semanas antes si va
          a someterse a una cirugía o si necesitará hacer reposo en cama. Tiene
          mayores probabilidades de presentar coágulos de sangre durante una
          cirugía o el reposo en cama.
        </p>
      </>
    ),
  },
  {
    title: 'Otros riesgos',
    body: (
      <>
        <p>
          Es posible que algunas mujeres que utilizan métodos anticonceptivos
          que contienen hormonas presenten:
        </p>
        {OTHER_RISKS_LIST && (
          <ul>
            {OTHER_RISKS_LIST.map((item, i) => (
              <li key={`faq-se-op-single${i}`}>{item}</li>
            ))}
          </ul>
        )}
        <p>
          Si siente que el implante se rompió o se dobló, comuníquese con su
          médico.
        </p>
      </>
    ),
  },
  {
    title: 'Implante roto o doblado',
    body: (
      <p>
        Puede ocurrir que, mientras está en su brazo, el implante se rompa o se
        doble debido a fuerzas externas (como la manipulación del implante o
        deportes de contacto). Es posible que un implante roto se desplace desde
        el sitio de la inserción. Si usted cree que el implante puede haberse
        roto o doblado mientras está en su brazo, comuníquese con su profesional
        de la salud.
      </p>
    ),
  },
];

export const SE_TABLE_3 = [
  {
    title: 'Dolor en la parte inferior de la pierna',
    body: 'que no desaparece',
  },
  {
    title: 'Dolor de pecho intenso',
    body: 'u opresión en el pecho',
  },
  {
    title: 'Dificultad repentina para respirar',
    body: 'o un fuerte dolor en el pecho o tos con sangre',
  },
  {
    title: 'Síntomas de una reacción alérgica grave',
    body: 'como hinchazón de la cara, la lengua o la garganta, o tiene dificultad para respirar o tragar',
  },
  {
    title: 'Dolor de cabeza intenso y repentino',
    body: 'distinto de los dolores de cabeza habituales',
  },
  {
    title: 'Debilidad o adormecimiento',
    body: 'en el brazo o en la pierna, o dificultad para hablar',
  },
  {
    title: 'Ceguera repentina',
    body: 'parcial o total',
  },
  {
    title: 'Color amarillento de la piel o la parte blanca de los ojos',
    body: 'en especial acompañado de fiebre, cansancio, pérdida del apetito, orina de color oscuro o heces de color claro',
  },
  {
    title: 'Dolor abdominal intenso o hinchazón',
    body: 'dolor intenso, hinchazón o sensibilidad en la parte inferior del abdomen',
  },
  {
    title: 'Un bulto en el seno',
    body: '',
  },
  {
    title: 'Problemas para dormir',
    body: 'o falta de energía, cansancio o mucha tristeza',
  },
  {
    title: 'Sangrado menstrual abundante',
    body: 'más abundante de lo normal',
  },
  {
    title: 'Un motivo para creer que el implante se ha roto o doblado',
    body: 'por cualquier motivo',
  },
];

export const WARNINGS_ITEMS_LIST = [
  'Está embarazada o cree que podría estarlo',
  'Tiene o tuvo coágulos de sangre, como coágulos de sangre en las piernas (trombosis venosa profunda), los pulmones (embolia pulmonar), los ojos (ceguera parcial o total), el corazón (ataque cardíaco) o el cerebro (accidente cerebrovascular)',
  'Tiene una enfermedad hepática o un tumor hepático',
  'Tiene sangrado vaginal sin motivo aparente',
  'Tiene o ha tenido cáncer de mama u otro tipo de cáncer sensible a la progestina (una hormona femenina)',
  'Es alérgica a algún componente de NEXPLANON',
];

export const WARNINGS_TITLE = 'No use NEXPLANON si usted…';
